module.exports = __webpack_public_path__ + "img/logo-arabic.e71c0b85.png";